import "../vars_spectrum-dark.css";
import $9vPgw$vars_spectrumdark_cssmjs from "../vars_spectrum-dark_css.mjs";
import "../vars_spectrum-darkest.css";
import $9vPgw$vars_spectrumdarkest_cssmjs from "../vars_spectrum-darkest_css.mjs";
import "../vars_spectrum-global.css";
import $9vPgw$vars_spectrumglobal_cssmjs from "../vars_spectrum-global_css.mjs";
import "../vars_spectrum-large.css";
import $9vPgw$vars_spectrumlarge_cssmjs from "../vars_spectrum-large_css.mjs";
import "../vars_spectrum-medium.css";
import $9vPgw$vars_spectrummedium_cssmjs from "../vars_spectrum-medium_css.mjs";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />





let $1471e418398142ae$export$3e936a8db52a10a0 = {
    global: ($parcel$interopDefault($9vPgw$vars_spectrumglobal_cssmjs)),
    light: (0, ($parcel$interopDefault($9vPgw$vars_spectrumdark_cssmjs))),
    dark: (0, ($parcel$interopDefault($9vPgw$vars_spectrumdarkest_cssmjs))),
    medium: ($parcel$interopDefault($9vPgw$vars_spectrummedium_cssmjs)),
    large: ($parcel$interopDefault($9vPgw$vars_spectrumlarge_cssmjs))
};


export {$1471e418398142ae$export$3e936a8db52a10a0 as darkTheme};
//# sourceMappingURL=darkTheme.mjs.map
